__webpack_require__.p = "https://sold-properties-card-mfe.living-ibex-live.aws.aviv.eu/v3/assets/mfes/avis/legacy/";